import logger from 'itrvl-logger';

// Setup logger
logger.setup(false, true);
window.logger = logger;

// common/utils/tss.js reads this at import; bootstrap moves it to the end of <head> before the first render.
const tssInsertionPoint = document.createElement('meta');
tssInsertionPoint.name = 'tss-insertion-point';
document.head.appendChild(tssInsertionPoint);

require('./bootstrap');
